module.exports = __webpack_public_path__ + "img/3.1af76c1d.webp";